import React from 'react';
import { Button } from '@chakra-ui/react';
import CloseIcon from '../../icons/CloseIcon/CloseIcon';
import { useTokens } from '../../../context/TokenProvider';
import { localise } from '../../../services/lang/lang';
export const ChipCloseButton = (props) => {
    const tokens = useTokens();
    const buttonStyle = {
        px: 0,
        py: 0,
        minH: tokens.Spacing05,
        minW: tokens.Spacing05,
        h: tokens.Spacing05,
        w: tokens.Spacing05,
        bgColor: 'transparent',
        borderRadius: 0,
        _focus: {
            shadow: 'none',
            outline: 'none',
        },
        _focusVisible: {
            shadow: 'none',
            outlineWidth: tokens.BorderWidth02,
            outlineColor: tokens.BorderFocus,
        },
    };
    return (React.createElement(Button, { type: "button", "aria-label": `${localise('REMOVE')} ${props.chipLabel}`, "data-testid": "chip-close-button", onClick: props.onClick, tabIndex: 0, sx: buttonStyle },
        React.createElement(CloseIcon, { width: "10px", fill: tokens.IconDark800 })));
};
